import { Injectable } from '@angular/core';

import { User } from '@common/models';
import { AppPermissionsService } from '@common/services';
import { LAYOUT_VERSION, LayoutVersion, setLayoutVersion } from 'app/layout-version';

/**
 * Switch entre la versión 1 (master) y la 2 (BRAIN) del layout, para los
 * administradores. Lo usan los dos headers: beliv-header (v1) y home-header
 * (v2).
 *
 * El cambio se guarda en localStorage y se aplica recargando (ver
 * app/layout-version.ts): la config, los estilos y el layout se arman al
 * arrancar.
 */
@Injectable({ providedIn: 'root' })
export class LayoutSwitchService {
  /** Versión que se está viendo */
  readonly currentVersion: LayoutVersion = LAYOUT_VERSION;

  /** Versión a la que lleva el switch */
  readonly targetVersion: LayoutVersion = LAYOUT_VERSION === 1 ? 2 : 1;

  constructor(
    private _appPermissionsService: AppPermissionsService
  ) {}

  /**
   * Solo los administradores ven el switch: el superusuario o quien tenga un
   * rol de administrador.
   * @param user Usuario autenticado
   */
  canSwitch(user: User): boolean {
    if (!user) return false;
    if (user.superUser === true) return true;

    return this._appPermissionsService.hasPermissionByUrl('pages/home#layout', 'READ');
  }

  /** Guarda la otra versión y recarga para aplicarla */
  switchLayout(): void {
    setLayoutVersion(this.targetVersion);
    window.location.reload();
  }
}
